import "./left_sidebar.css"
import {logError} from "../function.js";

let icon_arrow = `<svg height="18px" viewBox="0 0 24 24" width="18px" xmlns="http://www.w3.org/2000/svg"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path></svg>`;

export function left_side_bar_size() {
    try {
        var $sidebar = $(".left-sidebar:eq(1)");
        if (!$sidebar.length) return;
        if (document.body.offsetWidth > 1260) {
            $sidebar.children("div").css("width", $sidebar.width() + "px")
            $sidebar.children("div").css("left", $sidebar.offset().left + "px")
        }
    } catch (e) {
        logError(e)
    }
}


$(document).ready(function () {
    var $sidebar = $(".left-sidebar:eq(1)");
    if (!$sidebar.length) return;

    $(window).resize(function () {
        left_side_bar_size()
    });
    left_side_bar_size()

    function show() {
        try {

            $(".toggle_left_sidebar").removeClass("off")
            $sidebar.removeClass("ds-none")
            left_side_bar_size()
            jqueryts.storage.local.put("left_sidebar", "show")
            document.cookie = "left_sidebar=show; path=/";
        } catch (e) {
            logError(e)
        }
    }

    function hide() {
        try {
            $(".toggle_left_sidebar").addClass("off")
            $sidebar.addClass("ds-none")
            // $(".block-main").attr("class", "block-main p-relative col-lg-9 col-12")
            jqueryts.storage.local.put("left_sidebar", "hide")
            document.cookie = "left_sidebar=hide; path=/";
        } catch (e) {
            logError(e)
        }
    }

    $(".toggle_left_sidebar").on("click", function () {
        try {
            if (!$(this).hasClass("off")) {
                hide()
            } else {
                show()
            }
        } catch (e) {
            logError(e)
        }
    })

    if (jqueryts.storage.local.get("left_sidebar"))
        if (jqueryts.storage.local.get("left_sidebar") == "hide") {
            hide()
        } else {
            show();
        }

    function append_toggle(left_bar) {
        try {
            left_bar.each(function () {
                // console.log($(this))
                if ($(this).hasClass("active")) {
                    $(this).find(">a").append(`<span class="toggle open">${icon_arrow}</span>`)
                } else {
                    $(this).find(">a").append(`<span class="toggle">${icon_arrow}</span>`)
                }

                if ($(this).find("ul").length > 0) {
                    $(this).addClass("submenu"); // Добавляем класс has-submenu
                }
            });
        } catch (e) {
            logError(e)
        }
    }

    // Проверяем, есть ли у ссылки дочерний ul
    append_toggle($(".left-sidebar:eq(0) > ul  li "))
    append_toggle($sidebar.children("div").children("ul").children("li"))
    $(".left-sidebar").find("span.toggle").click(function (event) {
        try {
            // Получаем ссылку, связанную с псевдоэлементом
            const li = $(this).parent().parent();
            if ($(this).hasClass("open")) {
                li.find(">ul").hide()
                $(this).removeClass("open")
            } else {
                li.find(">ul").show()
                $(this).addClass("open")
            }
            return false;
        } catch (e) {
            logError(e)
        }
    });

    $(window).scroll(function () {
        left_scroll()
    });
    left_scroll();

    function left_scroll() {
        try {
            // return false;
            left_side_bar_size()
            const scrollTop = $(window).scrollTop();
            // фиксация меню
            if (document.body.offsetWidth < 1260) return false;

            if (scrollTop >= $(".header__top").outerHeight() + 50) {
                if ($("#sphinx_page>.block-main").outerHeight() <= $sidebar.children("div").outerHeight()) return false;
                $sidebar.children("div").addClass("left_bar_fix");
                var blockHeight = $(document).height() - scrollTop - $('.footer').outerHeight() - 90;
                $sidebar.children("div").css("max-height", blockHeight + "px")
            } else {
                $sidebar.children("div").removeClass("left_bar_fix");
                $sidebar.children("div").css("max-height", "none")
            }
        } catch (e) {
            logError(e)
        }
    }

    $("#version_sphinx").appendTo("#version_tag_block")

});